export const FETCH_AUCTION_BID_HISTORY_DATA = "FETCH_AUCTION_BID_HISTORY_DATA";
export const FETCH_AUCTION_BID_HISTORY_DATA_SUCCESS =
  "FETCH_AUCTION_BID_HISTORY_DATA_SUCCESS";
export const FETCH_AUCTION_BID_HISTORY_DATA_FAILURE =
  "FETCH_AUCTION_BID_HISTORY_DATA_FAILURE";
export const FETCH_AUCTION_BID_HISTORY_DATA_EXPORT_SUCCESS =
  "FETCH_AUCTION_BID_HISTORY_DATA_EXPORT_SUCCESS";
export const FETCH_AUCTION_BID_HISTORY_DATA_API_CALL =
  "FETCH_AUCTION_BID_HISTORY_DATA_API_CALL";

export const FETCH_AUCTION_BID_HISTORY_LOT_WISE_DATA =
  "FETCH_AUCTION_BID_HISTORY_LOT_WISE_DATA";
export const FETCH_AUCTION_BID_HISTORY_LOT_WISE_DATA_SUCCESS =
  "FETCH_AUCTION_BID_HISTORY_LOT_WISE_DATA_SUCCESS";
export const FETCH_AUCTION_BID_HISTORY_LOT_WISE_DATA_FAILURE =
  "FETCH_AUCTION_BID_HISTORY_LOT_WISE_DATA_FAILURE";
export const FETCH_AUCTION_BID_HISTORY_LOT_WISE_DATA_API_CALL =
  "FETCH_AUCTION_BID_HISTORY_LOT_WISE_DATA_API_CALL";

export const FETCH_SEARCH_DROP_DOWN_FOR_AUCTION_BID_HISTORY =
  "FETCH_SEARCH_DROP_DOWN_FOR_AUCTION_BID_HISTORY";
export const FETCH_SEARCH_DROP_DOWN_FOR_AUCTION_BID_HISTORY_SUCCESS =
  "FETCH_SEARCH_DROP_DOWN_FOR_AUCTION_BID_HISTORY_SUCCESS";
export const FETCH_SEARCH_DROP_DOWN_FOR_AUCTION_BID_HISTORY_FAILURE =
  "FETCH_SEARCH_DROP_DOWN_FOR_AUCTION_BID_HISTORY_FAILURE";
